export default __webpack_public_path__ + "static/media/menu.71929a53.svg";